import styled from 'styled-components';
import { fadeIn } from './Animations';

/**
 * Card de resultados (usado em listagens)
 */
export const ResultsCard = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem 2rem;
    background: white;
    border: 1px solid #e8e8e8;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    animation: ${fadeIn} 0.5s ease;
    transition: all 0.3s ease;
    box-sizing: border-box;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border-color: #d0d0d0;
    }

    @media (max-width: 768px) {
        padding: 0 1rem 1rem;
    }
`;

/**
 * Card de conteúdo (usado em formulários)
 */
export const ContentCard = styled.div`
    background: white;
    border-radius: 16px;
    padding: ${(props) => props.padding || '32px'};
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
    animation: ${fadeIn} 0.8s ease;
    box-sizing: border-box;
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: 768px) {
        padding: 24px;
    }
`;

/**
 * Card simples sem animação
 */
export const Card = styled.div`
    background: white;
    border-radius: ${(props) => props.borderRadius || '16px'};
    padding: ${(props) => props.padding || '24px'};
    box-shadow: ${(props) => props.shadow || '0 2px 8px rgba(0, 0, 0, 0.06)'};
    box-sizing: border-box;

    ${(props) => props.hoverable && `
        transition: all 0.3s ease;
        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
    `}
`;

/**
 * Card com bordas
 */
export const BorderedCard = styled(Card)`
    border: 1px solid ${(props) => props.borderColor || '#e8e8e8'};
`;

/**
 * Grid de cards
 */
export const CardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${(props) => props.minWidth || '300px'}, 1fr));
    gap: ${(props) => props.gap || '24px'};
    width: 100%;
`;

/**
 * Card de dashboard com header
 */
export const DashboardCard = styled.div`
    background: white;
    border-radius: 16px;
    padding: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    box-sizing: border-box;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
`;

/**
 * Header do card de dashboard
 */
export const CardHeader = styled.div`
    padding: 20px 24px;
    border-bottom: 1px solid #eef2f7;
    background: ${(props) => props.background || '#f9fafb'};
`;

/**
 * Título do card
 */
export const CardTitle = styled.h3`
    margin: 0;
    font-size: ${(props) => props.fontSize || '18px'};
    font-weight: 600;
    color: #1f2933;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Corpo do card
 */
export const CardBody = styled.div`
    padding: ${(props) => props.padding || '24px'};
`;

/**
 * Footer do card
 */
export const CardFooter = styled.div`
    padding: 16px 24px;
    border-top: 1px solid #eef2f7;
    background: #f9fafb;
    display: flex;
    justify-content: ${(props) => props.align || 'flex-end'};
    gap: 12px;
`;
